<template>
  <div>
    <page-title :heading=heading :icon=icon></page-title>
    <v-container>
      <v-layout>
        <v-flex class="ml-2" xs2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate"
              :rules="rules.required"
              :label="$t('employerReports.startDate')"
              prepend-icon="event"
              readonly
              v-on="on"
              outline
              class="fixed-height-textfield"
            ></v-text-field>
          </template>
            <v-date-picker
              color="primary"
              v-model="startDate"
              @input="menu = false"
              :max="today"
              :locale="$t('reportsType.local')">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="true"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
              :rules="rules.required"
                v-model="endDate"
                :label="$t('employerReports.endDate')"
                prepend-icon="event"
                readonly
                v-on="on"
                outline
                class="fixed-height-textfield"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              v-model="endDate"
              :min="startDate"
              :locale="$t('reportsType.local')"
              @input="menu = false"
              @change="dateVerify()"
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="userCompanySelected" :items="userCompany" :label="$t('expenseDetailEmployee.employee')" item-text="name" item-value="id" class="fixed-height" solo>
            <template v-slot:selection="{ item }">
              <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="selectedProject" :items="projects" :label="$t('general.projects')" item-value="id" item-text="name" class="fixed-height" solo>
            <template slot="item" slot-scope="data">
              {{ data.item.name }} - {{ data.item.status === 1 ? $t('projects.stat.active') : $t('projects.stat.inactive')}}
            </template>
            <template v-slot:selection="{ item }">
                <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                  {{ item.name }}
                </div>
              </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedStatus" :items="status" :rules="rules.required" :label="$t('general.status')" item-text="name" item-value="id" class="fixed-height" solo>
            <template slot="selection" slot-scope="data">
              {{ data.item.id === -1 ? data.item.name : $t('expenses.' + data.item.name)}}
            </template>
            <template slot="item" slot-scope="data">
              {{ data.item.id === -1 ? data.item.name : $t('expenses.' + data.item.name)}}
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs1>
          <v-btn @click="search()" :loading="loading" :disabled="disabled" color="primary" round depressed>{{ $t('general.filter') }}</v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="ml-2" xs5>
          <!-- PENDIENTE -->
          <!-- <v-text-field v-model="searchReport" :label="$t('general.search')" clearable append-outer-icon="search"></v-text-field> -->
        </v-flex>
        <v-flex class="ml-2 text-sm-right">
          <v-btn @click="downloadXls()" color='primary' round outline :loading="loadingDownload">
            {{$t('expenseDetailEmployee.download')}}
            <v-icon right>cloud_download</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="loadingItems">
        <v-flex>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <span>{{$t('general.loadingText')}}</span>
        </v-flex>
      </v-layout>
      <v-layout v-if="!loadingItems">
        <v-flex>
          <v-data-table
            class="elevation-1"
            :headers='headers'
            :items="expenses"
            :loading="loadingItems"
            :pagination.sync="pagination"
            :items-per-page="pagination.rowsPerPage"
            :total-items="pagination.totalItems"
            @update:pagination="checkPageChange"
            style="width: 100%"
          >
        <template v-slot:no-data v-if="expenses.length > 0">
          <center class="subtitle font-weight-light">{{$t('general.noDataText')}}</center>
        </template>

        <template v-slot:headers='props'>
          <tr class="bg-heavy-rain">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header)"
              >
              <h2 class="font-weight-black primary--text mb-0">
                  <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                  {{header.text}}
              </h2>
              </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr class="grey lighten-3" >
            <td class="text-xs-center" style="padding: 0px 10px">
              {{ props.item.id }} {{ getStatus(props.item.status_expense.name)}}
            </td>
            <td class="text-xs-center" style="padding: 0px 10px">{{ props.item.start_date }} | {{props.item.end_date}}</td>
            <td class="text-xs-center" style="padding: 0px 10px">{{ expenseType(props.item) }}</td>
            <td class="text-xs-center" style="padding: 0px 10px">{{ props.item.user.name }}</td>
            <td class="text-xs-center" style="padding: 0px 10px">{{ props.item.description }}</td>
            <td class="text-xs-center" style="padding: 0px 10px">{{ props.item.project.name }}</td>
            <td class="text-xs-center" style="padding: 0px 10px">{{ props.item.advance | formatCurrency }}</td>
            <td class="text-xs-center" style="padding: 0px 10px">{{ (+props.item.monto_mxn) + (+props.item.total_amount_tip) | formatCurrency }}</td>
            <td class="text-sm-center" style="padding: 0px 10px">
              <v-layout row justify-center>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                      <v-btn
                      style="margin-left: 2px; margin-right: 2px;"
                      :disabled="isDisabled(props.item.total_items)"
                        small
                        outline
                        icon
                        color="info"
                        v-on="on"
                        @click="getAcuse(props.item.id)"
                      >
                        <v-icon small>receipt</v-icon>
                      </v-btn>
                  </template>
                  <span>{{ $t('expenses.downloadAccuse') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn style="margin-left: 2px; margin-right: 2px;"
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="getHistory(props.item)"
                      >
                      <v-icon small>history</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.history') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn style="margin-left: 2px; margin-right: 2px;"
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="detail(props.item.id)"
                      >
                      <v-icon small>remove_red_eye</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('reportExpenseTracking.seeExpense') }}</span>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
        </v-flex>
      </v-layout>
      <v-dialog
        persistent
        v-model="histDialog"
        max-width="900px"
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{ $t('expenses.tracking') }}</h2>
          </v-toolbar>
          <v-card-text v-if="histLoading">
            <v-layout>
              <v-flex class="text-center">
                <v-progress-circular color="primary" indeterminate size="50"/>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text v-if="!histLoading">
              <v-layout wrap>
                <v-flex xs6>
                  <h3><span class="primary--text font-weight-black">{{$t('workflowValidation.expenseNo')}}: </span>{{histItem.id}}</h3>
                </v-flex>
                <v-flex xs6>
                  <h3><span class="primary--text font-weight-black">{{$t('general.workflow')}}: </span>{{workflowName}}</h3>
                </v-flex>
                <v-flex xs6>
                  <h3><span class="primary--text font-weight-black">{{$t('general.description')}}: </span>{{histItem.description}}</h3>
                </v-flex>
                <v-flex xs6>
                  <h3><span class="primary--text font-weight-black">{{$t('general.project')}}: </span>{{histItem.project.name}}</h3>
                </v-flex>
                <v-flex xs6>
                  <h3><span class="primary--text font-weight-black">{{$t('general.startDate')}}: </span>{{histItem.start_date}}</h3>
                </v-flex>
                <v-flex xs6>
                  <h3><span class="primary--text font-weight-black">{{$t('general.endDate')}}: </span>{{histItem.end_date}}</h3>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-divider/>
                  <h3 class="primary--text font-weight-black">{{$t('expenses.progress')}}:</h3>
                  <v-card flat color="grey lighten-3">
                    <v-layout>
                      <v-flex
                        class="text-center py-3"
                        :class="histSteps.sented.length > 0 ? 'hist-steps white--text' : 'grey--text'"
                        xs4
                      >
                        <v-avatar
                          class="mr-2"
                          size="20"
                          :color="histSteps.sented.length > 0 ? 'white' : 'grey'"
                        >
                          <v-icon v-if="histSteps.sented.length > 0" class="font-weight-black" small>check</v-icon>
                          <span v-else class="white--text font-weight-black">1</span>
                        </v-avatar>
                        <span class="font-weight-black my-3">{{$t('expenses.exs.sented')}}</span>
                      </v-flex>
                      <v-divider vertical/>
                      <v-flex
                        class="text-center py-3"
                        :class="histSteps.reviewed.length > 0 ? 'hist-steps white--text' : 'grey--text'"
                        xs4
                      >
                        <v-avatar
                          class="mr-2"
                          size="20"
                          :color="histSteps.reviewed.length > 0 ? 'white' : 'grey'"
                        >
                          <v-icon v-if="histSteps.reviewed.length > 0" class="font-weight-black" small>check</v-icon>
                          <span v-else class="white--text font-weight-black">2</span>
                        </v-avatar>
                        <span class="font-weight-black my-3">{{$t('expenses.exs.reviewed')}}</span>
                      </v-flex>

                      <v-divider vertical/>
                      <v-flex
                        class="text-center py-3"
                        :class="histSteps.payable.length ? 'hist-steps white--text' : 'grey--text'"
                        xs4
                      >
                        <v-avatar
                          class="mr-2"
                          size="20"
                          :color="histSteps.payable.length ? 'white' : 'grey'"
                        >
                          <v-icon v-if="histSteps.payable.length" class="font-weight-black" small>check</v-icon>
                          <span v-else class="white--text font-weight-black">3</span>
                        </v-avatar>
                        <span class="font-weight-black my-3">{{$t('expenses.exs.approved')}}</span>
                      </v-flex>
                      <v-divider vertical/>

                      <v-flex
                        class="text-center py-3"
                        :class="histSteps.paid.length ? 'hist-steps white--text' : 'grey--text'"
                        xs4
                      >
                        <v-avatar
                          class="mr-2"
                          size="20"
                          :color="histSteps.paid.length ? 'white' : 'grey'"
                        >
                          <v-icon v-if="histSteps.paid.length" class="font-weight-black" small>check</v-icon>
                          <span v-else class="white--text font-weight-black">4</span>
                        </v-avatar>
                        <span class="font-weight-black my-3">{{$t('expenses.exs.paid')}}</span>
                      </v-flex>

                    </v-layout>
                    <v-divider class="my-0 primary"/>
                    <v-layout>
                      <v-flex v-if="histSteps.sented.length > 0" class="text-center pa-3" xs4>
                        <h3 class="primary--text font-weight-black">{{$t('expenses.history.sented')}}:</h3>
                        <li
                          class="text-sm-left"
                        >{{histSteps.sented[0].user.name + ' - ' + histSteps.sented[0].created_at}}</li>
                      </v-flex>
                      <v-flex v-else class="text-center pa-3" xs4>
                        <h3 class="grey--text font-weight-black py-2">{{$t('expenses.history.pending')}}</h3>
                      </v-flex>
                      <v-divider class="primary" vertical/>
                      <v-flex v-if="histSteps.reviewed.length > 0" class="text-center pa-3" xs4>
                        <h3 class="primary--text font-weight-black">{{$t('expenses.history.reviewed')}}:</h3>
                        <li
                          class="text-sm-left"
                          v-for="step of histSteps.reviewed" :key="step.id"
                        >{{step.user.name + ' - ' + step.created_at}}</li>                        <!-- Lista de usuarios que aún no han revisado y faltan validar -->
                        <v-flex v-if="validatorsExpenses !== null && isApproved === false">
                          <h3 class="grey--text font-weight-black py-2">{{$t('expenses.history.pending')}}</h3>
                          <ul
                            class="text-sm-left"
                            v-for="validator of pendingValidators" :key="validator.validator.user_id"
                          >
                            <h6 class="text-center font-weight-black">{{$t('validator.name')}} {{validator.validatorId}}</h6>
                            {{validator.validator.user.name}}
                            <h6 v-if="validator.substitutes !== null" class="text-center grey--text pt-1">{{$t('general.substitutes')}}</h6>
                            <li v-if="validator.substitutes !== null"
                              class="text-sm-left grey--text"
                            >{{validator.substitutes.user.name}}</li>
                          </ul>
                          <v-spacer></v-spacer>
                        </v-flex>
                      </v-flex>
                      <v-flex v-else class="text-center pa-3" xs4>
                        <h3 class="grey--text font-weight-black py-2">{{$t('expenses.history.pending')}}</h3>
                        <ul v-for="validator of validators" :key="validator.id">
                          <h6 class="text-center font-weight-black">{{$t('validator.name')}} {{validator.validatorId}}</h6>
                          <li
                            class="text-sm-left grey--text"
                          >{{validator.validator.user.name}}</li>
                          <h6 v-if="validator.substitutes !== null" class="text-center grey--text pt-1">{{$t('general.substitutes')}}</h6>
                          <li v-if="validator.substitutes !== null"
                            class="text-sm-left grey--text"
                          >{{validator.substitutes.user.name}}</li>
                        <v-spacer></v-spacer>
                        </ul>
                      </v-flex>
                      <v-divider class="primary" vertical/>
                      <v-flex v-if="histSteps.payable.length > 0" class="text-center pa-3" xs4>
                        <h3 class="primary--text font-weight-black">{{$t('expenses.history.payable')}}:</h3>
                        <li
                          class="text-sm-left"
                          v-for="step of histSteps.payable" :key="step.id"
                        >{{step.user.name + ' - ' + step.created_at}}</li>
                      </v-flex>
                      <v-flex v-else class="text-center pa-3" xs4>
                        <h3 class="grey--text font-weight-black py-2">{{$t('expenses.history.pending')}}</h3>
                          <ul v-for="approver of approvers" :key="approver.id">
                           <li class="text-sm-left grey--text">{{approver.users[0].name}}</li>
                          </ul>
                      </v-flex>
                      <v-divider class="primary" vertical/>
                      <v-flex v-if="histSteps.paid.length > 0" class="text-center pa-3" xs4>
                        <h3 class="primary--text font-weight-black">{{$t('expenses.history.paid')}}:</h3>
                        <li class="text-sm-left" v-for="step of histSteps.paid" :key="step.id">{{step.user.name + ' - ' + step.created_at}}</li>
                      </v-flex>
                      <v-flex v-else class="text-center pa-3" xs4>
                        <h3 class="grey--text font-weight-black py-2">{{$t('expenses.history.pending')}}</h3>
                          <ul v-for="approver of approvers" :key="approver.id">
                            <li class="text-sm-left grey--text">
                              <!-- {{approver.users[0].name}} -->
                                <!-- ÚNICO CASO ARLETTE -->
                              {{ (userLogged && userLogged.company && userLogged.company[0] && (userLogged.company[0].id === 49 || userLogged.company[0].id === 50)) ? 'BARAJAS PEREZ ARLETTE DANIELA' : approver.users[0].name }}
                            </li>
                          </ul>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="close"
            >
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'reportExpenseTrackingComponent',
  data () {
    return {
      searchReport: '',
      expenses: [],
      year: new Date().getUTCFullYear(),
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      dialog: false,
      allUsers: true,
      areas: [],
      status: [],
      userCompany: [],
      categories: [],
      projects: [],
      switchCategories: true,
      switchAllStatus: true,
      selectedCategory: null,
      selectedStatus: null,
      selectedProject: null,
      selectedArea: null,
      userCompanySelected: null,
      statusSelected: '',
      areasSelected: '',
      projectsSelected: null,
      switchProjects: true,
      switchAreas: true,
      loading: false,
      loadingDownload: false,
      loadingItems: true,
      disabled: false,
      type: 'json',
      urlQuery: '',
      show: false,
      link: '',
      userLogged: {},
      valid: true,
      totalMonths: [],
      detailedData: [],
      expensesItems: null,
      selectedZip: null,
      valDownload: true,
      startDate: new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() === 0 ? 0 : new Date().getDay()))).toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      today: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      histDialog: false,
      histLoading: false,
      histItem: {
        id: 1,
        description: 'alguna vaina',
        start_date: '',
        end_date: '',
        project: {
          name: ''
        },
        progress: [],
        steps: [
          {
            status: 1,
            validator: [
              {
                id: 1,
                name: 'fulano'
              },
              {
                id: 2,
                name: 'fulano'
              }
            ]
          },
          {
            status: 2,
            validator: [
              {
                id: 1,
                name: 'fulano'
              }
            ]
          }
        ]
      },
      histSteps: {
        sented: [],
        reviewed: [],
        payable: [],
        paid: []
      },
      exCreated: [],
      exSented: [],
      exReviewed: [],
      exPayable: [],
      exPayment: [],
      exPaid: [],
      expensesStatus: [],
      validators: [],
      approvers: [],
      validatorsExpenses: [],
      workflowName: '',
      isApproved: false,
      pendingValidators: [],
      settings: {},
      initialPage: true
    }
  },
  created () {
    this.getLogged()
    // this.initialize()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    getHistory (item) {
      this.histLoading = true
      this.histItem = item
      this.histItem.progress = []
      this.$emit('getHistory', {id: item.id, context: this})
      this.$emit('getWorkflowValidatorApprover', {user_id: item.user.id, context: this})
      this.$emit('getExpensesValidators', {id: item.id, context: this})
      this.histDialog = true
    },
    getPendingValidators () {
      this.pendingValidators = this.validators
      this.histItem.progress.forEach(item => {
        this.pendingValidators = this.pendingValidators.filter(x => x.validator.user_id !== item.user_id)
      })
    },
    filterHistory () {
      if (this.histItem.progress.length > 0) {
        this.histSteps.sented = this.histItem.progress.filter(item => item.status === 'Enviado')
        this.histSteps.reviewed = this.histItem.progress.filter(item => item.status === 'Revisado')
        this.histSteps.payable = this.histItem.progress.filter(item => item.status === 'Aprobado')
        this.histSteps.paid = this.histItem.progress.filter(item => item.status === 'Pagado')
        if (this.histSteps.payable.length > 0) {
          this.isApproved = true
        }
        this.getPendingValidators()
      }
    },
    initialize () {
      return this.$emit('initialize', {company_id: this.$store.state.userLogged.company[0].id, context: this})
    },
    get () {
      return this.$emit('get', {context: this})
    },
    closed () {
      this.dialog = false
    },
    getExpenses () {
      this.search()
      return this.expenses
    },
    search () {
      this.type = 'json'
        this.loading = true
        this.disabled = true
        this.get()
    },
    downloadReport () {
      this.type = 'download'
      this.$emit('download', {context: this})
    },
    downloadXls () {
      this.loadingDownload = true
      // this.disabled = true
      this.downloadReport()
    },
    changeSort (header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    },
    getStatus (stat) {
      let str = ''
      switch (stat) {
        case 'exs.created':
          str = this.$t('expenses.exs.created')
          break
        case 'exs.sented':
          str = this.$t('expenses.exs.sented')
          break
        case 'exs.reviewed':
          str = this.$t('expenses.exs.reviewed')
          break
        case 'exs.payable':
          str = this.$t('expenses.exs.payable')
          break
        case 'exs.payment':
          str = this.$t('expenses.exs.payment')
          break
        case 'exs.paid':
          str = this.$t('expenses.exs.paid')
          break
        case 'exs.approved':
          str = this.$t('expenses.exs.approved')
          break
      }
      return str
    },
    dateVerify () {
      if (
        new Date(this.startDate).getTime() > new Date(this.endDate).getTime()
      ) {
        this.showAlert = true
        this.startDate = null
        this.endDate = null
        setTimeout(() => {
          this.showAlert = false
        }, 4000)
      }
    },
    getAcuse (id) {
      this.$emit('getAcuse', {
        id,
        context: this
      })
    },
    close () {
      this.dialog = false
      this.histDialog = false
      this.loading = false
      this.errors = {}
      this.isPettyCash = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()

      this.histSteps = { sented: [], reviewed: [], payable: [], paid: [] }
      this.approvers = []
    },
    detail (expenseId) {
      // Obtén la URL completa de la ruta utilizando this.$router.resolve()
      const route = this.$router.resolve('/expensesTracking/' + expenseId)
      const fullUrl = route.href

      // Abre la URL en una nueva pestaña
      window.open(fullUrl, '_blank')
      // this.$router.push('/expensesTracking/' + expenseId)
    },
    isDisabled (items) {
      if (items > 0) {
        return false
      } else {
        return true
      }
    },
    expenseType (item) {
      if (item.is_imported_expense === 1) return this.$t('expenses.travelExpense.title')
      if (item.petty_cash_type === 0 && item.is_blue_voucher) return this.$t('general.okBlue') 
      if (item.petty_cash_type === 1) return this.$t('pettyCash.pettyCash')
      if (item.petty_cash_type === 2) return this.$t('pettyCash.amexCard')
      if (parseFloat(item.advance) > 0) return this.$t('general.advance')
      if (parseFloat(item.advance) <= 0 && item.petty_cash_type === 0) return this.$t('general.refund')
    },
    checkPageChange () {
      if (this.initialPage) {
        this.initialPage = false
      } else {
        this.valSearch = ''
        this.get()
      }
    }
  },
  computed: {
    heading () {
      return this.$t('reportExpenseTracking.name')
    },
    icon () {
      return 'far fa-file-alt fa-fw icon-color'
    },
    options () {
      return {
        color: 'primary',
        elevation: 'elevation-2',
        medium: true,
        outline: true,
        round: true,
        rigth: true
      }
    },
    headers () {
      return [
        {
          text: '#',
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('general.period'),
          align: 'left',
          sortable: true,
          value: 'start_date'
        },
        {
          text: this.$t('general.type'),
          align: 'left',
          sortable: true,
          value: 'monto_mxn'
        },
        {
          text: this.$t('general.employee'),
          align: 'left',
          sortable: true,
          value: 'user.name'
        },
        {
          text: this.$t('general.description'),
          align: 'left',
          sortable: true,
          value: 'description'
        },
        {
          text: this.$t('general.project'),
          align: 'left',
          sortable: true,
          value: 'project.name'
        },
        {
          text: this.$t('general.advance'),
          align: 'left',
          sortable: true,
          value: 'advance'
        },
        {
          text: this.$t('general.amount') + ' ' + this.currencyTag,
          align: 'left',
          sortable: true,
          value: 'monto_mxn'
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    currencyTag () {
      if (this.settings !== undefined && this.settings.length > 0) {
        let currency = this.settings.find(x => x.setting_type.name === 'st.currency' && x.company_id === this.$store.state.userLogged.company[0].id)
        return currency === undefined ? 'MXN' : currency.value.c_Moneda
      }

      return ''
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    '$store.state.userLogged' () {
      if (this.$store.state.userLogged.company) {
        this.getLogged()
      }
    },
    validators () {
      this.getPendingValidators()
    },
    userLogged () {
      if (this.userLogged.company) {
        this.initialize()
        this.search()
      }
    },
    allUsers () {
      if (this.allUsers) {
        this.userCompanySelected = null
      }
    },
    switchCategories () {
      if (this.switchCategories) {
        this.selectedCategory = null
      }
    },
    switchAreas () {
      if (this.switchAreas) {
        this.selectedArea = null
      }
    },
    switchProjects () {
      if (this.switchProjects) {
        this.selectedProject = null
      }
    },
    dialog (val) {
      val || this.close()
    },
    userCompany () {
      if (this.userCompany !== undefined && this.userCompany.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allEmployees') }
        this.userCompanySelected = -1
        this.userCompany.unshift(objDefault)
      }
    },
    projects () {
      if (this.projects !== undefined && this.projects.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allProjects') }
        this.selectedProject = -1
        this.projects.unshift(objDefault)
      }
    },
    status () {
      if (this.status !== undefined && this.status.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allStatus') }
        this.selectedStatus = -1
        this.status.unshift(objDefault)
      }
    },
  }
}
</script>

<style scoped>
  .hist-steps{
    background-color: #63b225 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/reportExpenseTracking.component.vue